import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import Router from 'react-router/lib/Router'
import { syncHistoryWithStore } from 'react-router-redux'
import browserHistory from 'react-router/lib/browserHistory'
import injectTapEventPlugin from 'react-tap-event-plugin'

import configureStore from 'store/configureStore'
import createRoutes from 'routes'

const store = configureStore()
const history = syncHistoryWithStore(browserHistory, store)
injectTapEventPlugin()

render(
  <Provider store={store}>
    <Router routes={createRoutes(store)} history={history} />
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js